import { useState } from 'react';
import BloodhoundForm from '@/pages/DataInputsTemp/Operations/BloodhoundForm';
import SiteVisitsInputPage from './SiteVisitsInputPage';
import ShortPostingInputPage from './ShortPostingInputPage';
import '@/styles/OperationsManagementHub.scss';

const TABS = [
    { id: 'bloodhound', label: 'Bloodhound Score' },
    { id: 'site-visits', label: 'Site Visits' },
    { id: 'short-posting', label: 'Short Postings' },
];

const OperationsManagementHubPage = () => {
    const [activeTab, setActiveTab] = useState('bloodhound');

    return (
        <div className="ops-management-hub">
            <h1>Operations Management</h1>

            <div className="ops-tabs" role="tablist">
                {TABS.map(tab => (
                    <button
                        key={tab.id}
                        role="tab"
                        aria-selected={activeTab === tab.id}
                        className={`ops-tab${activeTab === tab.id ? ' ops-tab--active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="ops-tab-content" role="tabpanel">
                {activeTab === 'bloodhound' && <BloodhoundForm />}
                {activeTab === 'site-visits' && <SiteVisitsInputPage />}
                {activeTab === 'short-posting' && <ShortPostingInputPage />}
            </div>
        </div>
    );
};

export default OperationsManagementHubPage;